export const isValid = (date) => {
    if (!isNaN(date) && date instanceof Date)
        return date;
    return null;
};
export const toDateFormat = (date) => {
    return isValid(new Date(date));
};
toDateFormat.numeric = (date, dateFormat) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (date === null)
        return;
    const fmtl = new Intl.DateTimeFormat((_a = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.locales) !== null && _a !== void 0 ? _a : 'en', {
        day: (_c = (_b = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.options) === null || _b === void 0 ? void 0 : _b.day) !== null && _c !== void 0 ? _c : '2-digit',
        month: (_e = (_d = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.options) === null || _d === void 0 ? void 0 : _d.month) !== null && _e !== void 0 ? _e : '2-digit',
        year: (_g = (_f = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.options) === null || _f === void 0 ? void 0 : _f.year) !== null && _g !== void 0 ? _g : 'numeric',
    });
    return fmtl.format(toDateFormat(date));
};
toDateFormat.shortMonth = (date, dateFormat) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (date === null)
        return;
    const fmtl = new Intl.DateTimeFormat((_a = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.locales) !== null && _a !== void 0 ? _a : 'en', {
        day: (_c = (_b = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.options) === null || _b === void 0 ? void 0 : _b.day) !== null && _c !== void 0 ? _c : 'numeric',
        month: (_e = (_d = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.options) === null || _d === void 0 ? void 0 : _d.month) !== null && _e !== void 0 ? _e : 'short',
        year: (_g = (_f = dateFormat === null || dateFormat === void 0 ? void 0 : dateFormat.options) === null || _f === void 0 ? void 0 : _f.year) !== null && _g !== void 0 ? _g : 'numeric',
    });
    return fmtl.format(toDateFormat(date));
};
toDateFormat.startOfDay = (date) => {
    const startOfDay = new Date(date).setHours(0, 0, 0, 0);
    return isValid(new Date(startOfDay));
};
toDateFormat.endOfDay = (date) => {
    const endOfDay = new Date(date).setHours(23, 59, 59, 999);
    return isValid(new Date(endOfDay));
};
//# sourceMappingURL=dateFormat.js.map